import { Controller } from "../../lib/stimulus-shim"

// Controller pour l'affichage et l'interaction générale des profils
// Namespace: profiles - pour les vues publiques des profils  
export default class extends Controller {
  // CSP stricte : les onclick inline sont interdits sur la surface publique —
  // actions génériques pour ouvrir/fermer les <dialog> et revenir en arrière
  openDialog(event) {
    const id = event.params.dialog
    const dialog = id && document.getElementById(id)
    if (dialog) dialog.showModal()
  }

  closeDialog(event) {
    const id = event.params.dialog
    const dialog = id && document.getElementById(id)
    if (dialog) dialog.close()
  }

  goBack() {
    history.back()
  }

  static values = { 
    currentPage: Number
  }

  connect() {
    // Propriétaire : aucune collecte
    if (document.querySelector('meta[name="rho-owner"]')) return
    console.log("Profiles::Viewer controller connected", {
      currentPage: this.currentPageValue
    })
    
    this.setupScrollToTop()
    this.trackPageView()
  }

  // Remonter en haut de page lors des changements
  setupScrollToTop() {
    // Remonter doucement en haut lors des transitions
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Tracking simple de la vue de page
  trackPageView() {
    // Si Ahoy est disponible, tracker la vue
    if (window.ahoy) {
      window.ahoy.track('profile_page_view', {
        page_position: this.currentPageValue,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      })
    }
  }

  // Méthode pour copier l'URL de la page actuelle
  copyPageUrl(event) {
    event.preventDefault()
    
    const url = window.location.href
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        this.showToast('URL copiée dans le presse-papier!')
      }).catch(() => {
        this.fallbackCopyUrl(url)
      })
    } else {
      this.fallbackCopyUrl(url)
    }
  }

  // Fallback pour les navigateurs qui ne supportent pas l'API Clipboard
  fallbackCopyUrl(url) {
    const textArea = document.createElement('textarea')
    textArea.value = url
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      document.execCommand('copy')
      this.showToast('URL copiée dans le presse-papier!')
    } catch (err) {
      console.error('Erreur lors de la copie:', err)
      this.showToast('Impossible de copier l\'URL', 'error')
    }
    
    document.body.removeChild(textArea)
  }

  // Afficher un toast message simple avec styles profiles
  showToast(message, type = 'success') {
    // Créer un toast temporaire avec classe namespace profiles
    const toast = document.createElement('div')
    toast.className = `profiles-toast toast toast-top toast-center`
    
    const alertClass = type === 'error' ? 'alert-error' : 'alert-success'
    const iconName = type === 'error' ? 'circle-x' : 'circle-check'
    
    toast.innerHTML = `
      <div class="alert ${alertClass}">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <use href="#${iconName}"></use>
        </svg>
        <span>${message}</span>
      </div>
    `
    
    document.body.appendChild(toast)
    
    // Supprimer après 3 secondes
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast)
      }
    }, 3000)
  }

  // Partage natif sur mobile (si disponible)
  shareProfile(event) {
    event.preventDefault()
    
    const url = window.location.href
    const title = document.title
    
    if (navigator.share) {
      navigator.share({
        title: title,
        url: url
      }).catch((error) => {
        console.log('Erreur lors du partage:', error)
        // Fallback vers la copie d'URL
        this.copyPageUrl(event)
      })
    } else {
      // Fallback vers la copie d'URL
      this.copyPageUrl(event)
    }
  }

  // Gestion du mode plein écran (pour les PWA)
  toggleFullscreen(event) {
    event.preventDefault()
    
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((error) => {
        console.log('Erreur mode plein écran:', error)
      })
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }

  // Analytics avancés pour les profils
  trackInteraction(event) {
    const interactionType = event.params.type || 'click'
    const elementName = event.params.element || 'unknown'
    
    if (window.ahoy) {
      window.ahoy.track('profile_interaction', {
        page_position: this.currentPageValue,
        interaction_type: interactionType,
        element_name: elementName,
        timestamp: new Date().toISOString()
      })
    }
  }

  // Callbacks Stimulus
  currentPageValueChanged() {
    console.log("Current page changed in profiles viewer:", this.currentPageValue)
    this.trackPageView()
  }
}